import { Events } from 'backbone'

const EventAggregator = Object.assign({}, Events)
export default EventAggregator
